import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import SHA256 from 'crypto-js/sha256';
import logo from '../assets/logo.png';

const Login = () => {
  const navigate = useNavigate();
  const [password, setPassword] = useState('');

  const handleLogin = () => {
    if (!password) return alert('Şifreyi girin');
    const hashedPassword = SHA256(password).toString();
    const storedHash = localStorage.getItem('wallet_hash');
    
    if (hashedPassword === storedHash) {
      // alert('Başarıyla giriş yapıldı!');
      navigate('/dashboard');
    } else {
      alert('Geçersiz şifre!');
    }
  };

  return (
    <div className="login-desing">
	<img src={logo} alt="Etagram Logo" style={{ width: 120, marginBottom: 20 }} />
      <h1 className="text-2xl font-bold mb-4">Giriş Yap</h1>

      <input
        type="password"
        placeholder="Şifrenizi girin"
        value={password}
        onChange={(e) => setPassword(e.target.value)}
        className="w-full p-2 border rounded"
      />

      <button
        onClick={handleLogin}
        className="w-full bg-blue-600 text-white p-2 rounded mt-4"
      >
        Giriş Yap
      </button>
    </div>
  );
};

export default Login;
